module.exports = __webpack_public_path__ + "img/filter-black.fd6e5dab.svg";